<script>
import Layout from "../../../layouts/main";
import Swal from "sweetalert2";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "../../../../../app.config";
import CheckModal from "@/components/CheckModal";
import DontCopasst from "@/components/standard/Copass/DontExist";
import CopasstActAPI from "@/services/standards/copasst/copasstActAPI";
import Capacitacion from "@/components/standard/Copass/UltimaCapacitacion";
import CopasstAPI from "@/services/standards/copasst/copasstActAPI";
import CompanyItemsAPI from "@/services/items/companies_itemsAPI";
import ItemAPI from "@/services/items/itemsAPI";
import newScoresAPI from "../../../../services/newScores/newScoresAPI";
import employeeAPI from "../../../../services/employee/employeeAPI";

/**
 * Form elements component
 */
export default {
  page: {
    title: "1.1.7 Capacitación del Copasst",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    PageHeader,
    Capacitacion,
    CheckModal,
    DontCopasst,
  },
  data() {
    return {
      title: "1.1.7 Capacitación del Copasst",
      items: [
        {
          text: "Estándares",
          href: "/forms/estandares",
        },
        {
          text: "1.1.7 Capacitación del copasst",
          active: true,
        },
      ],

      companyID: this.$store.getters["company/getCompany"].id || null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      user: this.$store.state.auth || null,
      item: null,
      itemStatus: "No cumplido",
      employeeActive: 0,
      itemData: null,
      employee: [],
      copasstID: null,
      vigiaID: null,
      loading: true,
      // Nº de consultas que deciden qué rama renderizar (empleados activos,
      // copasst y vigía). loading solo baja cuando las 3 terminan, para no
      // mostrar el estado vacío (DontCopasst) mientras aún llegan los datos.
      pending: 3,
    };
  },
  methods: {
    getItemData() {
      ItemAPI.getItems(7)
        .then((response) => {
          this.itemData = response;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getItems() {
      CompanyItemsAPI.getStatus(this.companyID, 7)
        .then((response) => {
          this.item = response || null;
        })
        .catch((error) => {
          this.item = null;
          this.itemStatus = null;
          console.log(error);
        });
    },

    getStatusItem(id = 7) {
      CompanyItemsAPI.getStatus(this.companyID, id)
        .then((response) => {
          this.item = response || null;
          this.itemStatus = response.status !== undefined ? response.status : this.itemStatus;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    changeItemStatus(itemStatus) {
      const itemChange = {
        companies_id: this.companyID,
        item_id: 7,
        status: itemStatus,
      };
      newScoresAPI.calculateScores(itemChange)
        .then((response) => {
          Swal.fire({
            title: "¡Éxito!",
            text: "¡Se ha cambiado el estado del ítem con éxito!",
            icon: "success",
            confirmButtonClass: "btn btn-confirm mt-2",
          });
          setTimeout(() => window.location.reload(), 2000)
        })
        .catch((error) => {
          Swal.fire({
            title: "¡ERROR!",
            text: "¡No se ha actualizado el estado del ítem!",
            icon: "error",
            confirmButtonClass: "btn btn-confirm mt-2",
          });

          setTimeout(() => window.location.reload(), 2000)
          console.log(error);
        });
    },

    /**
     * This method indicates whether the company has a classification corresponding to
     * the permit for the item in question.
     * @param {JSON} item The item object.
     */
    allowAccess() {
      try {
        const item = this.itemData;
        if (item) {
          const classificationID =
            this.$store.getters["company/getCompany"].company_classification_id || null;
          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    goBack() {
      this.$router.go(-1);
    },

    /**
     * This method is used to send notification to SST user and SST company.
     * The sendNotification method import is required.
     * @param {Number} messageID - The message ID that will be associated to notification.
     * @param {Number} itemID - The item ID that will be associated to notification.
     */
    sendNotification(messageID, itemID) {
      const company = this.$store.getters["company/getCompany"];
      return sendNotification(company.id, company.id_diseno_sso, messageID, itemID);
    },

    /**
     * This method is used to knows if the user has the permission indicated
     * @param {String} name The name of the permission
     * @param {Array} roles the roles that permitted to access the action
     * @returns {Boolean} true if the user has the permission indicated or false if no
     */
    getRole(name, roles) {
      // Get the user role
      let role = this.$store.state.auth.info.role
        ? this.$store.state.auth.info.role
        : null;
      // If the user is logged
      if (role) {
        // If the roles array is not empty
        if (roles) {
          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false;
        } // Close if the roles arrays is not empty
        // If the roles arrays is empty
        else {
          // Know if the user role is in the roles indicated
          role = role === 1 || role === 2 || role === 3 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8;
        } // Close if the roles arrays is empty
        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions;
        // Know if the user has the permission indicated
        const enabled = permissions.find((permission) => permission.name === name);
        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false;
      } // Close if the user is logged
      // If the user is not logged
      else {
        return false;
      } // Close else the user is not logged
    },

    // Baja loading solo cuando terminan (ok o error) las 3 consultas que
    // definen la vista, evitando el parpadeo del estado vacío en empresas
    // que sí tienen copasst/vigía conformado.
    settleLoad() {
      this.pending = Math.max(0, this.pending - 1);
      if (this.pending === 0) {
        this.loading = false;
      }
    },

    getEmployee() {
      CopasstActAPI.getEmployee(this.companyID)
        .then((response) => {
          const copasst = response[1];
          this.employee = copasst;
          this.exist = true;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getActiveEmployees() {
      employeeAPI.AllEmployeesForCompanyActive(this.companyID)
        .then((response) => {
          this.employeeActive = response.employees;
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => this.settleLoad());
    },

    getCopasst() {
      CopasstAPI.getRecent(this.companyID)
        .then((response) => {
          this.copasstID = response.Recent_copasst;
          if (response.Recent_copasst) {
            this.copasstID = response.Recent_copasst;
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => this.settleLoad());
    },

    getvigia() {
      CopasstAPI.getRecentVigia2(this.companyID)
        .then((response) => {
          if (response.Recent_copasst) {
            this.vigiaID = response.Recent_copasst;
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => this.settleLoad());
    },
  },
  computed: {
    /**
     * Mensaje de estado vacio para el 1.1.7: cuando ya termino de cargar pero la
     * empresa aun no tiene Vigia (<10 trabajadores) ni COPASST (>=10) conformado
     * en el 1.1.6. Antes este caso caia al mismo spinner de carga y parecia que
     * la pantalla estaba colgada; ahora se muestra DontCopasst con este hint.
     */
    emptyStateMessage() {
      const company = this.$store.getters["company/getCompany"] || {};
      const name = company.social_reason || "la empresa";
      if (this.employeeActive < 10) {
        return `Aún no hay un Vigía de SST conformado para ${name}. Primero debes conformarlo en el ítem 1.1.6 para poder registrar su capacitación.`;
      }
      return `Aún no hay un COPASST conformado para ${name}. Primero debes conformarlo en el ítem 1.1.6 para poder registrar su capacitación.`;
    },
  },
  mounted() {
    this.getActiveEmployees();
    this.getEmployee();
    this.getCopasst();
    this.getvigia();
    this.getItems();
    this.getItemData();
    this.getStatusItem();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-md-12">
        <div v-if="loading">
          <div class="text-center">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </div>

        <div v-else-if="copasstID !== null && employeeActive >= 10">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="form-row col-md-6 col-sm-12">
                  <CheckModal>
                    <p class="text-justify">
                      Una vez conformado el
                      <b>Comité Paritario de Seguridad y Salud en el Trabajo Copasst</b>,
                      se deberá planear la primera reunión y capacitarlos inicialmente en
                      funciones, roles y responsabilidades del comité. <br />
                      <br />
                      Con el fin de cumplir con las responsabilidades asignadas, se deberá
                      capacitar al comité en: identificación de peligros, evaluación y
                      valoración de riesgos, inspecciones de Seguridad, investigación de
                      incidentes, accidentes y enfermedades laborales, así como realizar
                      la capacitación virtual de las 50 horas del SG SST.
                    </p>
                  </CheckModal>
                </div>

                <div class="form-row col-md-6 col-sm-12 pt-1">
                  <b-form-group id="statusInput" label-for="statusInput" class="col-sm-12" label="Estado del ítem">
                    <b-form-select v-on:change="changeItemStatus(itemStatus)"
                      :disabled="!getRole('Actualizar items', [1, 2, 3]) || !item || !allowAccess()" plain
                      class="selectpicker form-control" v-model="itemStatus">
                      <b-form-select-option value="Aprobado">Aprobado</b-form-select-option>
                      <b-form-select-option value="Pendiente">Pendiente</b-form-select-option>
                      <b-form-select-option value="No cumplido">No cumplido</b-form-select-option>
                    </b-form-select>
                  </b-form-group>
                </div>
              </div>

              <div class="d-flex justify-content-center">
                <iframe width="734" height="413" src="https://www.youtube.com/embed/yaZGC0ER8cA" title="COPASST"
                  frameborder="0" allow="clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen>
                </iframe>
              </div>

              <Capacitacion />
            </div>
          </div>
        </div>

        <div v-else-if="vigiaID !== null && employeeActive < 10">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="form-row col-md-6 col-sm-12">
                  <CheckModal>
                    <p class="text-justify">
                      Una vez conformado el
                      <b>Comité Paritario de Seguridad y Salud en el Trabajo Copasst</b>,
                      se deberá planear la primera reunión y capacitarlos inicialmente en
                      funciones, roles y responsabilidades del comité. <br />
                      <br />
                      Con el fin de cumplir con las responsabilidades asignadas, se deberá
                      capacitar al comité en: identificación de peligros, evaluación y
                      valoración de riesgos, inspecciones de Seguridad, investigación de
                      incidentes, accidentes y enfermedades laborales, así como realizar
                      la capacitación virtual de las 50 horas del SG SST.
                    </p>
                  </CheckModal>
                </div>

                <div class="form-row col-md-6 col-sm-12 pt-1">
                  <b-form-group id="statusInput" label-for="statusInput" class="col-sm-12" label="Estado del ítem">
                    <b-form-select v-on:change="changeItemStatus(itemStatus)"
                      :disabled="!getRole('Actualizar items', [1, 2, 3]) || !item || !allowAccess()" plain
                      class="selectpicker form-control" v-model="itemStatus">
                      <b-form-select-option value="Aprobado">Aprobado</b-form-select-option>
                      <b-form-select-option value="Pendiente">Pendiente</b-form-select-option>
                      <b-form-select-option value="No cumplido">No cumplido</b-form-select-option>
                    </b-form-select>
                  </b-form-group>
                </div>
              </div>

              <div class="d-flex justify-content-center">
                <iframe width="734" height="413" src="https://www.youtube.com/embed/yaZGC0ER8cA" title="COPASST"
                  frameborder="0" allow="clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen>
                </iframe>
              </div>

              <Capacitacion />
            </div>
          </div>
        </div>

        <div v-else>
          <DontCopasst :text="emptyStateMessage" />
        </div>
      </div>
    </div>
  </Layout>
</template>
